import { useCallback } from 'react';

export const useScrollToElement = () => {
  const scrollToElement = useCallback((selector) => {
    const element = document.querySelector(selector);
    if (element) {
        window.scrollTo({
            behavior: 'smooth',
            left: 0,
            top: element.offsetTop - 110,
        })
    }
  }, []);

  return scrollToElement;
}; 